import axiosService from '@/services/axios/axios.service';

export interface MinuteActivity {
  minute: number;
  keyboardCount: number;
  mouseCount: number;
  hasActivity: boolean;
}

export interface ActivitySegment {
  _id: string;
  uid: string;
  trackingTimeId: string;
  segmentStartTime: string;
  segmentEndTime: string;
  minuteActivity: MinuteActivity[];
  totalKeyboardCount: number;
  totalMouseCount: number;
  activeMinutes: number;
  activityLevel: number;
  repetitivePattern?: string;
  patternRepetitions?: number;
  keySequence?: string; // Full key sequence - only present if pattern detected (for evidence)
  createdAt: string;
  updatedAt: string;
}

/**
 * Get activity segments for a tracking time (admin)
 */
const getActivitySegmentsByTrackingTime = async (
  trackingTimeId: string,
): Promise<ActivitySegment[]> => {
  const res = await axiosService.get('activity-segment/admin/by-tracking-time', {
    params: { trackingTimeId },
  });
  return res.data;
};

/**
 * Get activity segments for a user (admin)
 */
const getActivitySegmentsByUid = async (uid: string): Promise<ActivitySegment[]> => {
  const res = await axiosService.get('activity-segment/admin/by-uid', {
    params: { uid },
  });
  return res.data;
};

/**
 * Get activity segments for a user and date range (admin)
 */
const getActivitySegmentsByUidAndDateRange = async (
  uid: string,
  startDate: string,
  endDate: string,
): Promise<ActivitySegment[]> => {
  const res = await axiosService.get('activity-segment/admin/by-uid-and-date-range', {
    params: { uid, startDate, endDate },
  });
  return res.data;
};

export {
  getActivitySegmentsByTrackingTime,
  getActivitySegmentsByUid,
  getActivitySegmentsByUidAndDateRange,
};

